import { useState } from "react";
import { API_BASE } from "../../config/apiConfig";
import { FiEye, FiEyeOff } from "react-icons/fi";

export default function UpdatePasswordForm({ onCancel, onSuccess }) {
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");

  const [showCur, setShowCur] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConf, setShowConf] = useState(false);

  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPw.length < 6)
      return setError("New password must be at least 6 characters.");

    if (newPw !== confirmPw)
      return setError("Passwords do not match.");

    setSaving(true);

    try {
      const token = sessionStorage.getItem("access_token");

      const res = await fetch(`${API_BASE}/api/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          current_password: currentPw,
          new_password: newPw,
        }),
      });

      const data = await res.json();

      if (!res.ok || !data.success)
        throw new Error(data.message || "Failed to update password.");

      // Clear form
      setCurrentPw("");
      setNewPw("");
      setConfirmPw("");

      // Pass message to Settings page
      onSuccess("Password updated successfully.");
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="w-full flex flex-col items-center">

      {/* Title */}
      <h1 className="mb-6">
        Change Password
      </h1>

      {/* Centered Form */}
      <form onSubmit={handleSubmit} className="w-full max-w-md space-y-5">

        <PasswordInput
          label="Current Password"
          type={showCur ? "text" : "password"}
          value={currentPw}
          onChange={setCurrentPw}
          toggle={() => setShowCur(!showCur)}
        />

        <PasswordInput
          label="New Password"
          type={showNew ? "text" : "password"}
          value={newPw}
          onChange={setNewPw}
          toggle={() => setShowNew(!showNew)}
        />

        <PasswordInput
          label="Confirm New Password"
          type={showConf ? "text" : "password"}
          value={confirmPw}
          onChange={setConfirmPw}
          toggle={() => setShowConf(!showConf)}
        />

        {error && (
          <p className="text-red-600 text-sm">{error}</p>
        )}

        <div className="flex gap-3 pt-2">
          <button
            type="submit"
            disabled={saving}
            className="flex-1 px-4 py-2 rounded bg-blue-600 text-white disabled:opacity-50"
          >
            {saving ? "Saving..." : "Update Password"}
          </button>

          <button
            type="button"
            onClick={onCancel}
            className="flex-1 px-4 py-2 rounded border hover:bg-gray-100"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

function PasswordInput({ label, type, value, onChange, toggle }) {
  const Icon = type === "password" ? FiEye : FiEyeOff;

  return (
    <div className="flex flex-col">
      <span className="text-gray-500 text-sm font-medium mb-1">{label}</span>

      <div className="relative">
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full border rounded px-3 py-2 pr-10"
        />
        <button
          type="button"
          onClick={toggle}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
        >
          <Icon size={18} />
        </button>
      </div>
    </div>
  );
}
